import MapPainter from "./callbackhandler/MapPainter";
import MapPaintHandler from "../map/MapPaintHandler";
import IsochroneHandler from "../map/IsochroneHandler";
import IsochronePainter from "./callbackhandler/IsochronePainter";
import IsochroneWheel from "./gui/IsochroneWheel";
import DataHandler from "../data/DataHandler";
import TimeNavigator from "./callbackhandler/TimeNavigator";
import TimeWheel from "./gui/TimeWheel";
import IsochroneLocation from "./callbackhandler/IsochroneLocation";

export default class TangibleDictionary {
  #idToCb: { [key: number]: any };

  constructor() {
    const datahandler = new DataHandler();
    const painthandler = new MapPaintHandler(datahandler);
    const isochronehandler = new IsochroneHandler(datahandler);

    this.#idToCb = {
      18: new MapPainter(painthandler),
      22: new MapPainter(painthandler),
      10: new MapPainter(painthandler),
      11: new MapPainter(painthandler),
      9: new IsochronePainter(new IsochroneWheel(9), isochronehandler),
      14: new IsochronePainter(new IsochroneWheel(14), isochronehandler),
      19: new IsochronePainter(new IsochroneWheel(19), isochronehandler),
      12: new TimeNavigator(new TimeWheel(12)),
      35: new IsochroneLocation(isochronehandler),
    };
  }

  translateIDtoCallbackHandler(id: number) {
    if (this.#idToCb.hasOwnProperty(id)) {
      return this.#idToCb[id];
    } else {
      return null;
    }
  }
}
